import * as nodePath from 'node:path';
import type { FrameworkName, Framework, PackageJson } from '@bolt/framework-detection';
import { frameworks, getFramework, isBuildCommand } from '@bolt/framework-detection';
import type { TemplateID } from '~/templates';
import type { AppFiles } from '~/types/files';
import { WORK_DIR } from '~/utils/constants';

export type { FrameworkName, Framework, PackageJson };
export { frameworks, getFramework, isBuildCommand };

export const NETLIFY_TOML = 'netlify.toml';
export const PACKAGE_JSON = 'package.json';
export const PACKAGE_LOCK = 'package-lock.json';
export const BOLT_CONFIG_JSON = '.bolt/config.json';

export interface BoltConfigJson {
  template?: TemplateID;
  build?: {
    command: string;
    output: string;
  };
}

export function readPackageJson(files: AppFiles): PackageJson | undefined {
  const paths = Object.keys(files);
  const relative = nodePath.join(WORK_DIR, PACKAGE_JSON);

  if (paths.includes(relative) && files[relative]?.type === 'file') {
    try {
      return JSON.parse(files[relative].contents);
    } catch {}
  }

  return undefined;
}
